import React from 'react';
import './Header.css'
import Zoom from 'react-reveal/Zoom';

const ReactDeveloper = () => {
    return (
        <div className='ReactDeveloper'>
        <Zoom>
            <p>React Developer</p>
            </Zoom>
        </div>
    );
};

export default ReactDeveloper;